import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.css"],
})
export class LoadingComponent implements OnInit {
  constructor() {}
  @Input() isLoading: boolean;
  @Input() isFullSize: boolean;
  @Input() isAbsolute: boolean = true;
  @Input() isFixed: boolean = false;


  ngOnInit(): void {
    
  }
}
